import { TireReferencesPopup } from './TireReferencesPopup';

export default TireReferencesPopup;
